import { Route, Routes } from 'react-router';
import ErrorPage from './page/Error';
import PageDataLoader from './page/PageDataLoader';

function App() {
  return (
    <Routes>
      <Route path="/500" element={<ErrorPage />} />
      <Route path="/*" element={<PageDataLoader />} />
    </Routes>
  );
}

export default App;
